var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-row",
    [
      _c(
        "v-col",
        { staticClass: "px-2", attrs: { cols: "12", sm: "6", md: "5" } },
        [
          _c(
            "v-row",
            { attrs: { "no-gutters": "" } },
            [
              _c(
                "v-badge",
                {
                  attrs: { color: "accent", overlap: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "badge",
                      fn: function() {
                        return [
                          _vm.countFilters === 0
                            ? _c(
                                "v-icon",
                                {
                                  attrs: { color: "white" },
                                  on: {
                                    click: function($event) {
                                      _vm.dialog = true
                                    }
                                  }
                                },
                                [_vm._v("fa-plus")]
                              )
                            : _c(
                                "span",
                                {
                                  staticStyle: { color: "white" },
                                  on: {
                                    click: function($event) {
                                      _vm.dialog = true
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.countFilters))]
                              )
                        ]
                      },
                      proxy: true
                    }
                  ])
                },
                [
                  _c(
                    "v-tooltip",
                    {
                      attrs: { bottom: "" },
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function(ref) {
                            var on = ref.on
                            return [
                              _c(
                                "v-btn",
                                _vm._g(
                                  {
                                    attrs: { icon: "" },
                                    on: {
                                      click: function($event) {
                                        _vm.dialog = true
                                      }
                                    }
                                  },
                                  on
                                ),
                                [_c("v-icon", [_vm._v(" fa-filter ")])],
                                1
                              )
                            ]
                          }
                        }
                      ])
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("global.filters")) + " ")]
                  )
                ],
                1
              ),
              _vm.countFilters > 0
                ? _c(
                    "div",
                    { staticStyle: { "margin-top": "10px" } },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("global.filters")) +
                          ": " +
                          _vm._s(_vm.countFilters) +
                          " " +
                          _vm._s(_vm.$t("global.active")) +
                          " "
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: { icon: "" },
                          on: { click: _vm.clearFilters }
                        },
                        [
                          _c("v-icon", { attrs: { color: "grey" } }, [
                            _vm._v("clear")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c("v-checkbox", {
                staticClass: "ml-3 mt-1",
                attrs: { label: _vm.$t("global.expandAll") },
                model: {
                  value: _vm.contextShowAll,
                  callback: function($$v) {
                    _vm.contextShowAll = $$v
                  },
                  expression: "contextShowAll"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c("v-spacer"),
      _c(
        "v-col",
        { staticClass: "px-2", attrs: { cols: "12", sm: "6", md: "3" } },
        [
          _c(
            "v-row",
            { attrs: { "no-gutters": "" } },
            [
              _c("booking-column-select", {
                staticStyle: { "max-width": "80%" },
                attrs: {
                  "available-columns": _vm.availableColumns,
                  "selected-columns": _vm.contextSelectedColumns
                },
                on: {
                  "update:availableColumns": function($event) {
                    _vm.availableColumns = $event
                  },
                  "update:available-columns": function($event) {
                    _vm.availableColumns = $event
                  },
                  "update:selectedColumns": function($event) {
                    _vm.contextSelectedColumns = $event
                  },
                  "update:selected-columns": function($event) {
                    _vm.contextSelectedColumns = $event
                  }
                }
              }),
              _vm.downloadable
                ? _c(
                    "v-tooltip",
                    {
                      attrs: { bottom: "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function(ref) {
                              var on = ref.on
                              return [
                                _c(
                                  "v-btn",
                                  _vm._g(
                                    {
                                      staticClass: "mt-3",
                                      attrs: {
                                        disabled:
                                          _vm.$store.getters["Ajax/loading"],
                                        icon: "",
                                        large: ""
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.$emit("download")
                                        }
                                      }
                                    },
                                    on
                                  ),
                                  [
                                    _c("v-icon", { attrs: { large: "" } }, [
                                      _vm._v("cloud_download")
                                    ])
                                  ],
                                  1
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        4065027427
                      )
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("global.downloadFile")) + " ")]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "1200px" },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-card",
            { staticClass: "pa-3" },
            [
              _c("v-card-title", [
                _c("span", { staticClass: "headline" }, [
                  _vm._v(" " + _vm._s(_vm.$t("global.filters")) + " ")
                ])
              ]),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-row",
                    { attrs: { "no-gutters": "" } },
                    [
                      _c(
                        "v-col",
                        { staticClass: "py-0", attrs: { cols: "12", sm: "6" } },
                        [
                          _c(
                            "v-row",
                            { attrs: { "no-gutters": "" } },
                            [
                              typeof _vm.filters.fromDate !== "undefined"
                                ? _c("date-picker", {
                                    staticClass: "px-2",
                                    attrs: {
                                      "prepend-icon": "fa-calendar",
                                      model: _vm.contextFilters.fromDate,
                                      clearable: true,
                                      label: _vm.$t("global.fromDate"),
                                      placeholder: _vm.$t("global.any")
                                    },
                                    on: {
                                      "update:model": function($event) {
                                        return _vm.$set(
                                          _vm.contextFilters,
                                          "fromDate",
                                          $event
                                        )
                                      }
                                    }
                                  })
                                : _vm._e(),
                              typeof _vm.filters.toDate !== "undefined"
                                ? _c("date-picker", {
                                    staticClass: "px-2",
                                    attrs: {
                                      "prepend-icon": "fa-calendar",
                                      model: _vm.contextFilters.toDate,
                                      clearable: true,
                                      label: _vm.$t("global.toDate"),
                                      placeholder: _vm.$t("global.any")
                                    },
                                    on: {
                                      "update:model": function($event) {
                                        return _vm.$set(
                                          _vm.contextFilters,
                                          "toDate",
                                          $event
                                        )
                                      }
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          ),
                          _c(
                            "v-row",
                            { attrs: { "no-gutters": "" } },
                            [
                              typeof _vm.filters.fromIssueDate !== "undefined"
                                ? _c("date-picker", {
                                    staticClass: "px-2",
                                    attrs: {
                                      "prepend-icon": "fa-calendar",
                                      model: _vm.contextFilters.fromIssueDate,
                                      clearable: true,
                                      label:
                                        _vm.$t("booking.issueDate") +
                                        " " +
                                        _vm.$t("global.fromDate"),
                                      placeholder: _vm.$t("global.any")
                                    },
                                    on: {
                                      "update:model": function($event) {
                                        return _vm.$set(
                                          _vm.contextFilters,
                                          "fromIssueDate",
                                          $event
                                        )
                                      }
                                    }
                                  })
                                : _vm._e(),
                              typeof _vm.filters.toIssueDate !== "undefined"
                                ? _c("date-picker", {
                                    staticClass: "px-2",
                                    attrs: {
                                      "prepend-icon": "fa-calendar",
                                      model: _vm.contextFilters.toIssueDate,
                                      clearable: true,
                                      label:
                                        _vm.$t("booking.issueDate") +
                                        " " +
                                        _vm.$t("global.toDate"),
                                      placeholder: _vm.$t("global.any")
                                    },
                                    on: {
                                      "update:model": function($event) {
                                        return _vm.$set(
                                          _vm.contextFilters,
                                          "toIssueDate",
                                          $event
                                        )
                                      }
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          ),
                          _c(
                            "v-row",
                            { attrs: { "no-gutters": "" } },
                            [
                              typeof _vm.filters.fromSaleDate !== "undefined"
                                ? _c("date-picker", {
                                    staticClass: "px-2",
                                    attrs: {
                                      "prepend-icon": "fa-calendar",
                                      model: _vm.contextFilters.fromSaleDate,
                                      clearable: true,
                                      label:
                                        _vm.$t("booking.saleDate") +
                                        " " +
                                        _vm.$t("global.fromDate"),
                                      placeholder: _vm.$t("global.any")
                                    },
                                    on: {
                                      "update:model": function($event) {
                                        return _vm.$set(
                                          _vm.contextFilters,
                                          "fromSaleDate",
                                          $event
                                        )
                                      }
                                    }
                                  })
                                : _vm._e(),
                              typeof _vm.filters.toSaleDate !== "undefined"
                                ? _c("date-picker", {
                                    staticClass: "px-2",
                                    attrs: {
                                      "prepend-icon": "fa-calendar",
                                      model: _vm.contextFilters.toSaleDate,
                                      clearable: true,
                                      label:
                                        _vm.$t("booking.saleDate") +
                                        " " +
                                        _vm.$t("global.toDate"),
                                      placeholder: _vm.$t("global.any")
                                    },
                                    on: {
                                      "update:model": function($event) {
                                        return _vm.$set(
                                          _vm.contextFilters,
                                          "toSaleDate",
                                          $event
                                        )
                                      }
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          ),
                          typeof _vm.filters.selectedTypes !== "undefined"
                            ? _c(
                                "v-col",
                                { staticClass: "py-0" },
                                [
                                  _c("v-autocomplete", {
                                    attrs: {
                                      multiple: "",
                                      "prepend-icon": "fa-hand-holding-usd",
                                      label: _vm.$t("global.serviceTypes"),
                                      "small-chips": "",
                                      items: _vm.availableServiceTypes,
                                      "item-text": "name",
                                      "item-value": "type",
                                      placeholder: _vm.$t("global.any"),
                                      clearable: ""
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "selection",
                                          fn: function(ref) {
                                            var item = ref.item
                                            var index = ref.index
                                            return [
                                              index <= 3
                                                ? _c(
                                                    "v-chip",
                                                    {
                                                      attrs: {
                                                        color: "primary",
                                                        "text-color": "white",
                                                        small: ""
                                                      }
                                                    },
                                                    [
                                                      item.name.length < 13
                                                        ? _c("span", [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  item.name
                                                                ) +
                                                                " "
                                                            )
                                                          ])
                                                        : _c("span", [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  item.name.substring(
                                                                    0,
                                                                    13
                                                                  )
                                                                ) +
                                                                "... "
                                                            )
                                                          ])
                                                    ]
                                                  )
                                                : _vm._e(),
                                              index === 4
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "grey--text caption"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "(+" +
                                                          _vm._s(
                                                            _vm.contextFilters
                                                              .selectedTypes
                                                              .length - 4
                                                          ) +
                                                          " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "global.others"
                                                            )
                                                          ) +
                                                          ")"
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      1846920814
                                    ),
                                    model: {
                                      value: _vm.contextFilters.selectedTypes,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.contextFilters,
                                          "selectedTypes",
                                          $$v
                                        )
                                      },
                                      expression: "contextFilters.selectedTypes"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          typeof _vm.filters.passengers !== "undefined"
                            ? _c(
                                "v-col",
                                { staticClass: "py-0" },
                                [
                                  typeof _vm.filters.passengers !== "undefined"
                                    ? _c("v-autocomplete", {
                                        attrs: {
                                          multiple: "",
                                          "prepend-icon": "fa-users",
                                          label: _vm.$t("global.passengers"),
                                          "small-chips": "",
                                          items: _vm.availablePassengers,
                                          placeholder: _vm.$t("global.any"),
                                          clearable: ""
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "selection",
                                              fn: function(ref) {
                                                var item = ref.item
                                                var index = ref.index
                                                return [
                                                  index <= 2
                                                    ? _c(
                                                        "v-chip",
                                                        {
                                                          attrs: {
                                                            color: "primary",
                                                            "text-color":
                                                              "white",
                                                            small: ""
                                                          }
                                                        },
                                                        [
                                                          item.length < 18
                                                            ? _c("span", [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      item
                                                                    ) +
                                                                    " "
                                                                )
                                                              ])
                                                            : _c("span", [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      item.substring(
                                                                        0,
                                                                        18
                                                                      )
                                                                    ) +
                                                                    "... "
                                                                )
                                                              ])
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  index === 3
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "grey--text caption"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "(+" +
                                                              _vm._s(
                                                                _vm
                                                                  .contextFilters
                                                                  .passengers
                                                                  .length - 3
                                                              ) +
                                                              " " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "global.others"
                                                                )
                                                              ) +
                                                              ")"
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          3469668701
                                        ),
                                        model: {
                                          value: _vm.contextFilters.passengers,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.contextFilters,
                                              "passengers",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "contextFilters.passengers"
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            : _vm._e(),
                          typeof _vm.filters.organizationUnit !== "undefined"
                            ? _c(
                                "v-col",
                                { staticClass: "py-0" },
                                [
                                  _c("v-autocomplete", {
                                    attrs: {
                                      multiple: "",
                                      "prepend-icon": "fa-sitemap",
                                      label: _vm.$t("booking.organizationUnit"),
                                      "small-chips": "",
                                      items: _vm.availableOrganizationUnits,
                                      placeholder: _vm.$t("global.any"),
                                      clearable: ""
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "selection",
                                          fn: function(ref) {
                                            var item = ref.item
                                            var index = ref.index
                                            return [
                                              index <= 2
                                                ? _c(
                                                    "v-chip",
                                                    {
                                                      attrs: {
                                                        color: "primary",
                                                        "text-color": "white",
                                                        small: ""
                                                      }
                                                    },
                                                    [
                                                      item.length < 18
                                                        ? _c("span", [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(item) +
                                                                " "
                                                            )
                                                          ])
                                                        : _c("span", [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  item.substring(
                                                                    0,
                                                                    18
                                                                  )
                                                                ) +
                                                                "... "
                                                            )
                                                          ])
                                                    ]
                                                  )
                                                : _vm._e(),
                                              index === 3
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "grey--text caption"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "(+" +
                                                          _vm._s(
                                                            _vm.contextFilters
                                                              .organizationUnit
                                                              .length - 3
                                                          ) +
                                                          " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "global.others"
                                                            )
                                                          ) +
                                                          ")"
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      1722479993
                                    ),
                                    model: {
                                      value:
                                        _vm.contextFilters.organizationUnit,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.contextFilters,
                                          "organizationUnit",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "contextFilters.organizationUnit"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          typeof _vm.filters.reservationNumbers !== "undefined"
                            ? _c(
                                "v-col",
                                { staticClass: "py-0" },
                                [
                                  _c("v-autocomplete", {
                                    attrs: {
                                      multiple: "",
                                      "prepend-icon": "fa-clipboard-list",
                                      label: _vm.$t("global.reservationNumber"),
                                      "small-chips": "",
                                      items: _vm.availableReservationNumbers,
                                      placeholder: _vm.$t("global.any"),
                                      clearable: ""
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "selection",
                                          fn: function(ref) {
                                            var item = ref.item
                                            var index = ref.index
                                            return [
                                              index <= 2
                                                ? _c(
                                                    "v-chip",
                                                    {
                                                      attrs: {
                                                        color: "primary",
                                                        "text-color": "white",
                                                        small: ""
                                                      }
                                                    },
                                                    [
                                                      item.length < 18
                                                        ? _c("span", [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(item) +
                                                                " "
                                                            )
                                                          ])
                                                        : _c("span", [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  item.substring(
                                                                    0,
                                                                    18
                                                                  )
                                                                ) +
                                                                "... "
                                                            )
                                                          ])
                                                    ]
                                                  )
                                                : _vm._e(),
                                              index === 3
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "grey--text caption"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "(+" +
                                                          _vm._s(
                                                            _vm.contextFilters
                                                              .reservationNumbers
                                                              .length - 3
                                                          ) +
                                                          " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "global.others"
                                                            )
                                                          ) +
                                                          ")"
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      695283692
                                    ),
                                    model: {
                                      value:
                                        _vm.contextFilters.reservationNumbers,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.contextFilters,
                                          "reservationNumbers",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "contextFilters.reservationNumbers"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          typeof _vm.filters.isDomestic !== "undefined"
                            ? _c(
                                "v-col",
                                { staticClass: "py-0" },
                                [
                                  typeof _vm.filters.isDomestic !== "undefined"
                                    ? _c("v-select", {
                                        attrs: {
                                          "prepend-icon": "fa-globe-americas",
                                          label: _vm.$t("global.travelType"),
                                          items: _vm.isDomesticFilter
                                        },
                                        model: {
                                          value: _vm.contextFilters.isDomestic,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.contextFilters,
                                              "isDomestic",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "contextFilters.isDomestic"
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            : _vm._e(),
                          typeof _vm.filters.grossAbove !== "undefined"
                            ? _c(
                                "v-col",
                                { staticClass: "py-0" },
                                [
                                  _c(
                                    "v-row",
                                    { attrs: { "no-gutters": "" } },
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "px-2",
                                          attrs: { cols: "6" }
                                        },
                                        [
                                          _c("amount-input", {
                                            attrs: {
                                              label: _vm.$t(
                                                "booking.servicePriceAbove"
                                              ),
                                              "prepend-icon":
                                                "fa-money-bill-wave",
                                              model:
                                                _vm.contextFilters.grossAbove,
                                              clearable: "",
                                              placeholder: _vm.$t(
                                                "global.noLimit"
                                              )
                                            },
                                            on: {
                                              "update:model": function($event) {
                                                return _vm.$set(
                                                  _vm.contextFilters,
                                                  "grossAbove",
                                                  $event
                                                )
                                              }
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "px-2",
                                          attrs: { cols: "6" }
                                        },
                                        [
                                          _c("amount-input", {
                                            attrs: {
                                              label: _vm.$t(
                                                "booking.servicePriceBellow"
                                              ),
                                              "prepend-icon":
                                                "fa-money-bill-wave",
                                              model:
                                                _vm.contextFilters.grossUnder,
                                              clearable: "",
                                              placeholder: _vm.$t(
                                                "global.noLimit"
                                              )
                                            },
                                            on: {
                                              "update:model": function($event) {
                                                return _vm.$set(
                                                  _vm.contextFilters,
                                                  "grossUnder",
                                                  $event
                                                )
                                              }
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _c("v-col", { attrs: { cols: "12", sm: "6" } }, [
                        _c(
                          "fieldset",
                          { staticClass: "custom-fieldset" },
                          [
                            _c("legend", [
                              _vm._v(_vm._s(_vm.$t("booking.refersToGroup")))
                            ]),
                            typeof _vm.filters.countAbove !== "undefined"
                              ? _c(
                                  "v-col",
                                  [
                                    _c(
                                      "v-row",
                                      { attrs: { "no-gutters": "" } },
                                      [
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "px-2",
                                            attrs: { cols: "6" }
                                          },
                                          [
                                            _c("amount-input", {
                                              attrs: {
                                                label: _vm.$t(
                                                  "booking.countAbove"
                                                ),
                                                "prepend-icon": "fa-calculator",
                                                model:
                                                  _vm.contextFilters.countAbove,
                                                clearable: "",
                                                placeholder: _vm.$t(
                                                  "global.noLimit"
                                                )
                                              },
                                              on: {
                                                "update:model": function(
                                                  $event
                                                ) {
                                                  return _vm.$set(
                                                    _vm.contextFilters,
                                                    "countAbove",
                                                    $event
                                                  )
                                                }
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "px-2",
                                            attrs: { cols: "6" }
                                          },
                                          [
                                            _c("amount-input", {
                                              attrs: {
                                                label: _vm.$t(
                                                  "booking.countBellow"
                                                ),
                                                "prepend-icon": "fa-calculator",
                                                model:
                                                  _vm.contextFilters.countUnder,
                                                clearable: "",
                                                placeholder: _vm.$t(
                                                  "global.noLimit"
                                                )
                                              },
                                              on: {
                                                "update:model": function(
                                                  $event
                                                ) {
                                                  return _vm.$set(
                                                    _vm.contextFilters,
                                                    "countUnder",
                                                    $event
                                                  )
                                                }
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            typeof _vm.filters.grossSumAbove !== "undefined"
                              ? _c(
                                  "v-col",
                                  [
                                    _c(
                                      "v-row",
                                      { attrs: { "no-gutters": "" } },
                                      [
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "px-2",
                                            attrs: { cols: "6" }
                                          },
                                          [
                                            _c("amount-input", {
                                              attrs: {
                                                label: _vm.$t(
                                                  "booking.grossAmountAbove"
                                                ),
                                                "prepend-icon":
                                                  "fa-money-bill-wave",
                                                model:
                                                  _vm.contextFilters
                                                    .grossSumAbove,
                                                placeholder: _vm.$t(
                                                  "global.noLimit"
                                                ),
                                                clearable: ""
                                              },
                                              on: {
                                                "update:model": function(
                                                  $event
                                                ) {
                                                  return _vm.$set(
                                                    _vm.contextFilters,
                                                    "grossSumAbove",
                                                    $event
                                                  )
                                                }
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "px-2",
                                            attrs: { cols: "6" }
                                          },
                                          [
                                            _c("amount-input", {
                                              attrs: {
                                                label: _vm.$t(
                                                  "booking.grossAmountBellow"
                                                ),
                                                "prepend-icon":
                                                  "fa-money-bill-wave",
                                                model:
                                                  _vm.contextFilters
                                                    .grossSumUnder,
                                                placeholder: _vm.$t(
                                                  "global.noLimit"
                                                ),
                                                clearable: ""
                                              },
                                              on: {
                                                "update:model": function(
                                                  $event
                                                ) {
                                                  return _vm.$set(
                                                    _vm.contextFilters,
                                                    "grossSumUnder",
                                                    $event
                                                  )
                                                }
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            typeof _vm.filters.grossAverageAbove !== "undefined"
                              ? _c(
                                  "v-col",
                                  [
                                    _c(
                                      "v-row",
                                      { attrs: { "no-gutters": "" } },
                                      [
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "px-2",
                                            attrs: { cols: "6" }
                                          },
                                          [
                                            _c("amount-input", {
                                              attrs: {
                                                label: _vm.$t(
                                                  "booking.averagePriceAbove"
                                                ),
                                                "prepend-icon": "fa-chart-line",
                                                model:
                                                  _vm.contextFilters
                                                    .grossAverageAbove,
                                                placeholder: _vm.$t(
                                                  "global.noLimit"
                                                ),
                                                clearable: ""
                                              },
                                              on: {
                                                "update:model": function(
                                                  $event
                                                ) {
                                                  return _vm.$set(
                                                    _vm.contextFilters,
                                                    "grossAverageAbove",
                                                    $event
                                                  )
                                                }
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "px-2",
                                            attrs: { cols: "6" }
                                          },
                                          [
                                            _c("amount-input", {
                                              attrs: {
                                                label: _vm.$t(
                                                  "booking.averagePriceBellow"
                                                ),
                                                "prepend-icon": "fa-chart-line",
                                                model:
                                                  _vm.contextFilters
                                                    .grossAverageUnder,
                                                placeholder: _vm.$t(
                                                  "global.noLimit"
                                                ),
                                                clearable: ""
                                              },
                                              on: {
                                                "update:model": function(
                                                  $event
                                                ) {
                                                  return _vm.$set(
                                                    _vm.contextFilters,
                                                    "grossAverageUnder",
                                                    $event
                                                  )
                                                }
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "blue darken-1", text: "" },
                      on: {
                        click: function($event) {
                          _vm.dialog = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("global.close")))]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }